import React, { useState, useMemo, useEffect, useCallback } from "react";
import {
  TextField,
  Grid,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Slider,
  Tooltip,
  Stack,
  FormControlLabel,
  Checkbox, Dialog, DialogActions, DialogTitle, Divider, DialogContent, DialogContentText, Link,
  Collapse,
  Popover,
  useTheme,
  ListSubheader
} from "@mui/material";
import PropTypes from "prop-types";
import HistoryIcon from '@mui/icons-material/History';
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPromptHistory,
  promptsSelector,
  removeHistoryPrompts,
  setRunPromptId,
  setSelectedPromptData,
  triggerCopyPrompt,
  triggerCreatePrompt,
  triggerUpdatePrompt,
} from "../../../../store/slices/prompts";
import {
  companiesSelector,
  fetchUsers,
} from "../../../../store/slices/company";
import {
  convertArrayToDictionary,
  defaultGuid,
  getDefailtGpt5xVal,
  hasLowReasoningEffortFloor,
  normalizeReasoningEffort,
  promptTypesOptions,
} from "../../../../common/utils";
import moment from "moment";
import _, { subtract } from "lodash";
import HistoryPromptDetails from "./historyPromptDetails";
import { locationsSelector } from "../../../../store/slices/location";
import ComparePrompt from "../comparePrompt";
import PromptSelectDropdown from "./promptSelectDropdown";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Label } from "@mui/icons-material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useNavigate } from "react-router";
import { factsSelector, setFactLocalState } from "../../../../store/slices/facts";
import { gptUsageLimit, llmList } from "../constant";
import { isValidJSON } from "../reviewComponents/reviewUtils";



const requiredFields = ['name', 'type', 'subType', 'llm'];
const PromptDetail = ({
  setSelectedPrompt,
  setRefresh,
  jsonResponseSchemValue,
  setJsonResponseSchemaValue,
  refresh,
  data,
  isNew,
  setIsNew,
  setName,
  name,
  type,
  setType,
  llm,
  cached, setCached,
  seed, setSeed,
  version,
  setVersion,
  subType,
  setSubType,
  setLlm,
  handleLLMChange,
  api,
  setApi,
  reviewType,
  setReviewType,
  passReviews,
  setPassReviews,
  description,
  setDescription,
  temperature,
  setTemperature,
  presencePenalty,
  maxLength,
  frequencyPenalty,
  topP,
  setTopP,
  setFrequencyPenalty,
  inputFactor,
  setInputFactor,
  jsonResponse,
  setJsonResponse,
  jsonResponseSchema,
  setJsonResponseSchema,
  deepResearch,
  setDeepResearch,
  promptText,
  setPresencePenalty,
  setMaxLength,
  setPromptText,
  systemPrompt, setSystemPrompt,
  companyId,
  promptId,
  scope,
  handleClickOpen,
  handleAssignClickOpen,
  openDeleteModal,
  openAssignModal,
  handleAssignClose,
  handleAssignPrompt,
  isAssignPrompt,
  handleClose,
  handleDelete,
  handleCopy,
  buttonText = "Submit",
  verbosity,
  setVerbosity,
  reasoning_effort,
  setReasoningEffort,
  setCompanyPromptData,
  companyPromptData,
  nextPromptId,
  setNextPromptId,
  web_search, setWeb_search,
  // runPromptId, setRunPromptId,
  setSelectedTab
}) => {
  const { users, promptTypes } = useSelector(locationsSelector);
  const dispatch = useDispatch();
  const [openCopyWarning, setOpenCopyWarning] = useState(false)
  const [openHistory, setOpenHistory] = useState(false)
  const [openCompare, setOpenCompare] = useState(false)
  const {selectedPromptData, envAssignments} = useSelector(promptsSelector)
  const { prompts } = useSelector(locationsSelector);
  const {localState:{factDevelopment}} = useSelector(factsSelector);
  const [advOpt, setAdvOpt] = useState(false);
  const [advOptAnchorEl, setAdvOptAnchorEl] = useState(null);
  const [openArchiveModal, setOpenArchiveModal] = useState(false);
  const [promptName, setPromptName] = useState("");
  const [isTemperatureChecked, setIsTemperatureChecked] = useState(true);
  const [isTopPChecked, setIsTopPChecked] = useState(true);
  // const [nextPromptId, setNextPromptId] = useState(null);
  const [promptType, setPromptType] = useState("");
  const [typeAnchorEl, setTypeAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [runButton, setRunButton] = useState("Run Prompt");
  const [error, setError] = useState({});
  const theme = useTheme();
  
  const navigate = useNavigate();
  // useEffect(() => {
  //   dispatch(fetchUsers(companyId));
  // }, [companyId]);
  const subTypeMemo = useCallback((type) => {
    switch (type) {
      case 'Phrase Summary':
        return ['Category', 'Topic']
      case 'Response':
        return ['Free Responder', 'With Text', 'Without Text']
      case 'Agent':
        return ['Determine Name', 'Fact Relevance', 'Fact Relevance RwoT', 'Employee Name', 'Determine Alphabet', 'Translation', 'Inappropriate Instructions', 'PHI', 'Review Validation', 'Custom']
      case 'Review Request':
        return ['Email', 'SMS', 'WhatsApp', 'ALL', 'Parse PDF']
      case 'Report':
        return ['Red Flag Report']
      case 'Business':
        return ['Topics', 'Similar Business Types', 'Default MRT Setting', "RwoT Phrases", "Facts",'Website Research']
      case 'Chat':
        return ["Ferryhopper","Custom"]
      case 'Sentiments':
        return ["Review"]
      case 'Other':
        return ["Custom"]
      default:
        return []
        break;
    }
  }, [type, selectedPromptData])
  
  useEffect(() => {
    if (data) {
      setName(data.name || "");
      setType(data.type||"");
      setLlm(data.llm || "");
      setVersion(data?.version);
      setSubType(data?.subType || (data?.type === 'Review Request' && !data?.subType ? null : (promptTypes?.[0]?.promptSubType ?? null)))
      setReviewType(data.reviewSelectionType || "None");
      setPassReviews(data?.processSingleReview);
      setDescription(data.description || "");
      setPromptText(data.promptText || "");
      setSystemPrompt(data.systemPrompt || "");
      setJsonResponseSchemaValue(data?.responseJsonSchema || '')
      // setCompanyPromptData((prev) => ({ ...prev, assign: data?.assignCompanyId === companyId ? true : false }));
      if (data.defaultParameters) {
        const defaultParams = JSON.parse(data.defaultParameters);

        if ("temperature" in defaultParams && defaultParams.temperature != null && defaultParams.temperature !== '') {
          setIsTemperatureChecked(true);
          setTemperature(parseFloat(defaultParams.temperature));
        } else {
          setIsTemperatureChecked(false);
          setTemperature(0);
        }
         if ("verbosity" in defaultParams) {
          setVerbosity(defaultParams.verbosity);
        } else {
          setVerbosity('medium');
        }
        if ("reasoning_effort" in defaultParams) {
          setReasoningEffort(normalizeReasoningEffort(data.llm, defaultParams.reasoning_effort));
        } else {
          setReasoningEffort(getDefailtGpt5xVal(llm));
        }
        if ('seed' in defaultParams) {
          setSeed(defaultParams.seed)
        }
        else {
          setSeed('None')
        }
        if ("topP" in defaultParams && defaultParams.topP != null && defaultParams.topP !== '') {
          setIsTopPChecked(true);
          setTopP(parseFloat(defaultParams.topP));
        } else {
          setIsTopPChecked(false);
          setTopP(0);
        }

        if ("presencePenalty" in defaultParams) {
          setPresencePenalty(parseFloat(defaultParams.presencePenalty));
        } else {
          setPresencePenalty(0);
        }

        if ("maxLength" in defaultParams) {
          setMaxLength(parseInt(defaultParams.maxLength));
        } else {
          setMaxLength(500);
        }

        if ("frequencyPenalty" in defaultParams) {
          setFrequencyPenalty(parseFloat(defaultParams.frequencyPenalty));
        } else {
          setFrequencyPenalty(0);
        }
        if ("inputFactor" in defaultParams) {
          setInputFactor(parseInt(defaultParams.inputFactor));
        } else {
          setInputFactor(40);
        }
        if ("jsonResponse" in defaultParams) {
          setJsonResponse(Boolean(defaultParams.jsonResponse));
        } else {
          setJsonResponse(false);
        }
        if ("isJsonResponseSchema" in defaultParams) {
          setJsonResponseSchema(Boolean(defaultParams.isJsonResponseSchema));
        } else {
          setJsonResponseSchema(false);
        }
        if ("deepResearch" in defaultParams) {
          setDeepResearch(Boolean(defaultParams.deepResearch));
        } else {
          setDeepResearch(false);
        }
        if("api" in defaultParams){
          setApi(defaultParams.api);
        }else{
          setApi("completions");
        }if(defaultParams.api==='responses' && "nextPromptId" in defaultParams){
          setNextPromptId(defaultParams.nextPromptId);
        }else{
          setNextPromptId(null);
        }
        if("cached" in defaultParams){
          setCached(Boolean(defaultParams.cached));
        } else {
          setCached(false);
        }
        if("web_search" in defaultParams){
          setWeb_search(Boolean(defaultParams.web_search));
        }else{
          setWeb_search(false);
        }
      }
    }
  }, [data]);
  const handleOpenCopyWarning = () => {
    setOpenCopyWarning(true)
  }
  const handleCloseCopyWarning = () => {
    setOpenCopyWarning(false)
  }
  const handleOpenHistory = () => {
    if (data?.promptId) {
      dispatch(fetchPromptHistory(data?.promptId))
    }
    setOpenHistory(true)
  }
  const handleCloseHistory = () => {
    dispatch(removeHistoryPrompts())
    setOpenHistory(false)
  }
  const handleCloseCompare = () => {
    setOpenCompare(false)
  }
  const handleOpenCompare = () => {
    setOpenCompare(true)
  }
  const handleCopyModal = () => {
    handleCopy()
    handleCloseCopyWarning()
  }
  useEffect(() => {
    if (isNew) {
      setName("");
      setType("");
      setSubType('');
      setLlm("");
      setReviewType("None");
      setPassReviews(true);
      setDescription("");
      setTemperature(0);
      setIsTemperatureChecked(true);
      setIsTopPChecked(true);
      setTopP(0);
      setSeed('None');
      setInputFactor(40);
      setJsonResponse(false);
      setJsonResponseSchema(false);
      setDeepResearch(false);
      setJsonResponseSchemaValue(null)
      setPresencePenalty(0);
      setMaxLength(500);
      setFrequencyPenalty(0);
      setPromptText("");
      setSystemPrompt("");
    }
  }, [isNew, selectedPromptData]);

const promptsDic = useMemo(() => {
  return convertArrayToDictionary(prompts, "promptId");
}, [prompts]);

  const handleSubmit = () => {
    if (isJsonSchemaInvalid) {
      return;
    }
    const actionCompanyId = scope === "Global" ? defaultGuid : companyId;
    _.map(requiredFields, (field) => {
      if (!field?.trim()) {
        setError((prev)=>({...prev, [field]: true}));
      }
    });
    if(_.size(_.compact(_.values(error)))>0) {
      return;

    }
    let obj = {
      assignCompanyId: selectedPromptData?.assignCompanyId || data?.assignCompanyId || actionCompanyId,
      name: name,
      type: type,
      description: description,
      reviewSelectionType: reviewType,
      promptText: promptText,
      systemPrompt: systemPrompt,
      llm: llm,
      responseJsonSchema: jsonResponseSchemValue,
      version: version,
      subType: subType === "" ? null : subType,
      processSingleReview: passReviews,
      defaultParameters: JSON.stringify({
        verbosity: (_.includes(llm, 'gpt-5') || _.includes(llm, 'gpt-6')) ? verbosity : 'medium',
        reasoning_effort: normalizeReasoningEffort(llm, reasoning_effort),
        temperature: isTemperatureChecked ? (temperature ?? 0) : null,
        seed: seed,
        maxLength: maxLength,
        presencePenalty: presencePenalty,
        frequencyPenalty: frequencyPenalty,

        inputFactor: inputFactor,
        jsonResponse: jsonResponse,
        isJsonResponseSchema: jsonResponseSchema,
        deepResearch: deepResearch,
        topP: isTopPChecked ? (topP ?? 0) : null,
        api: api,
        nextPromptId: api==='responses' ? nextPromptId : null,
        cached: cached,
        web_search: web_search,
      }),
    };
    if (!_.isEmpty(subType)) {
      obj = { ...obj, subType }
    }
    if (isNew) {
      dispatch(triggerCreatePrompt(actionCompanyId, obj));
      setSelectedPrompt({});
      setIsNew(false);
    } else {
      dispatch(triggerUpdatePrompt(promptId, actionCompanyId, obj, data));
      // dispatch(setSelectedPromptData(data))
    }
    setTimeout(() => {
      setRefresh(!refresh);
    }, 1000);
  };
  useEffect(()=>{
    if(isNew){
      setError({
        name: !name?.trim(),
        type: !type?.trim(),
        subType: !subType?.trim(),
        llm: !llm?.trim()
      });
    }else{
      setError({});
    }
  },[error, name, type, subType, llm, promptId, isNew])
  
useEffect(()=>{
  if (data?.promptId) {
    dispatch(setSelectedPromptData(promptsDic[data?.promptId]));
  }
},[prompts])
  const handleSliderChange = (slider) => (event, newValue) => {
    switch (slider) {
      case "temperature":
        setTemperature(newValue);
        break;
      case "presencePenalty":
        setPresencePenalty(newValue);
        break;
      case "maxLength":
        setMaxLength(newValue * 1000);
        break;
      case "frequencyPenalty":
        setFrequencyPenalty(newValue);
        break;
      case "inputFactor":
        setInputFactor(newValue);
        break;
      case "topP":
        setTopP(newValue);
        break;
      default:
        break;
    }
  };
  const userDic = React.useMemo(
    () =>
      convertArrayToDictionary(
        _.map(_.cloneDeep(users), (it) => {
          it.name = it.firstName + (it.lastName ? " " + it.lastName : "");
          return it;
        }),
        "userId"
      ),
    [users]
  );
  const ValueLabelComponent = (props) => {
    const { children, value } = props;
    return (
      <Tooltip enterTouchDelay={0} placement="top" title={value + "k"} arrow>
        {children}
      </Tooltip>
    );
  };
  ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.number.isRequired,
  };
  const handleType = (value) => {
    const typeFunc = () => {
      switch (value) {
        case 'Phrase Summary':
          return ['Category', 'Topic']
        case 'Response':
          return ['Free Responder', 'With Text', 'Without Text']
        case 'Agent':
          return ['Determine Name', 'Fact Relevance', 'Fact Relevance RwoT', 'Employee Name', 'Determine Alphabet', 'Translation', 'Inappropriate Instructions', 'PHI', 'Review Validation', 'Custom',]
        case 'Review Request':
          return ['Email', 'SMS', 'WhatsApp', 'ALL', 'Parse PDF']
        case 'Report':
          return ['Red Flag Report']
        default:
          return []
          break;
      }
    }
    setType(value)
    if (_.includes(['Agent', 'Response', 'Phrase Summary', 'Review Request'], value)) {
      return setSubType(typeFunc()?.[0])
    }
    else {
      setSubType('')
    }
  }

  const handleAdvOptOpen=(event)=>{
    setAdvOptAnchorEl(event.currentTarget);
    setAdvOpt(true);
  }
  const handleAdvOptClose=()=>{
    setAdvOptAnchorEl(null);
    setAdvOpt(false);
  }
  const deleteCompanyPrompt = ()=>{
    setCompanyPromptData((prev) => ({ ...prev, remove: true }));
    handleClickOpen();
  }
  const handleAssignClick = ()=>{
    setCompanyPromptData((prev) => ({ ...prev, assign: true }));
    handleAssignClickOpen();
  }
  const handleArchivedDialogOpen = ()=>{
    setOpenArchiveModal(true);
  }
  const handleArchiveDialogClose = ()=>{
    setOpenArchiveModal(false);
  }
  const handleArchivePrompt = ()=>{
      if(!promptId) return;
     
      dispatch(triggerUpdatePrompt(promptId, companyId, {...selectedPromptData, status: 3 }, data, "Archived"))
      // setCompanyPromptData((prev) => ({...prev, }));

      handleArchiveDialogClose();
  }
  const isGloballyOrCompanyAssigned = useMemo(() => {
    const currentPromptId = _.toLower(data?.promptId || promptId || '');
    if (!currentPromptId) return false;
    const hasEnvAssignment = _.some(envAssignments, (item) => _.toLower(item?.promptId) === currentPromptId && item?.subType === data?.subType);
    if (hasEnvAssignment) return true;
    return false;;
  }, [envAssignments, data, promptId]);
  const isValidPrompt = useMemo(()=>!!(isNew || promptId),[isNew, promptId]);
  const isJsonSchemaInvalid = useMemo(() => {
    if (!jsonResponseSchema || !jsonResponseSchemValue) return false;
    try {
      const parsed = JSON.parse(jsonResponseSchemValue);
      return !(parsed && typeof parsed === 'object' && !Array.isArray(parsed));
    } catch (e) {
      return true;
    }
  }, [jsonResponseSchema, jsonResponseSchemValue]);
  const isSaveDisabled = useMemo(() => !isValidPrompt || isJsonSchemaInvalid, [isValidPrompt, isJsonSchemaInvalid]);
  const minimalLabel = useMemo(()=>{
    
    return getDefailtGpt5xVal(llm)
  },[llm, reasoning_effort]);

  // console.log('minimalLabel', minimalLabel);
  
  // const typesAndSubtypes = useMemo(()=>{
  // let typeOptions = ['Agent', 'Business', 'Phrase Summary', 'Response', 'Review Request', 'Sentiments', 'Chat','Report', 'Other'];
  
  //  const lowerSearch = _.toLower(searchTerm);

  // return _.reduce(typeOptions, (acc, type) => {
  //   const subTypes = subTypeMemo(type);

  //   const typeMatches = _.includes(
  //     _.toLower(type),
  //     lowerSearch
  //   );

  //   const filteredSubTypes = _.filter(subTypes, subType =>
  //     _.includes(
  //       _.toLower(subType),
  //       lowerSearch
  //     )
  //   );

  //   if (typeMatches) {
  //     acc[type] = subTypes;
  //     return acc;
  //   }

  //   if (filteredSubTypes.length > 0) {
  //     acc[type] = filteredSubTypes;
  //   }

  //   return acc;
  // }, {});
  // },[prompts, searchTerm]);


  const promptTypeSubTypeData = useMemo(()=>{
    return promptTypesOptions(promptTypes, searchTerm);
  }, [promptTypes, searchTerm]);
  
  const handleTypeChange = (type, subType)=>{
    setType(type);
    setSubType(subType);
    setTypeAnchorEl(null);
  }
  useEffect(()=>{
    
    if (selectedPromptData?.type === "Business" && selectedPromptData?.subType === "Website Research" || selectedPromptData?.type === "Response" || selectedPromptData?.type === "Sentiments") {
        setRunButton("Test Prompt")
    } else {
       setRunButton("Run Prompt")
    }
  },[selectedPromptData])
  

  const handleTestRunPrompt = useCallback(()=>{
    if (selectedPromptData?.type === "Business" && selectedPromptData?.subType === "Website Research") {
        dispatch(setRunPromptId(promptId))
        dispatch(setFactLocalState({key:'factDevelopment', data:{...factDevelopment, inputData:{...factDevelopment?.inputData, websiteResearchPromptId:promptId}}, type:'factInputData'}));
        navigate(`/facts`);

    }else if(selectedPromptData?.type ){
      const type = selectedPromptData?.type
      switch(type){
        case "Response":
          navigate(`/responses`);
          break;
        case "Sentiments":
          navigate(`/sentiments`);
          break;
        default:
          navigate('/prompts')
          setSelectedTab(1);
          break;
      }
       dispatch(setRunPromptId(promptId));
    } else {
      dispatch(setRunPromptId(promptId));
      setSelectedTab(1);
    }
       
  }, [promptId, factDevelopment]);
  

  return (
    <Box sx={{ overflow: "hidden"  }}>
      
        {/* Moved buttons from Stack */}        
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', borderBottom: '1px solid #888' , height: '53px'}}>

        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleSubmit}
          // style={{ marginTop: "16px" }}
          disabled={isSaveDisabled}
          sx={{ textTransform: 'none' }}
        >
          {buttonText}
        </Button>
        
        {data?.promptId && (
          <Button variant="text" component={Link} disabled={!promptId} onClick={handleOpenHistory} sx={{ textTransform: 'none', paddingLeft: 0.75, paddingRight: 0.75, '&:hover': { backgroundColor: 'transparent' }, display: 'flex', alignItems: 'center', gap: '2px' }}>
            {/* <HistoryIcon fontSize="small" />  */}
            History
          </Button>
        )}
         <Button variant="text" component={Link} disabled={!promptId} onClick={handleOpenCompare} sx={{ textTransform: 'none', paddingLeft: 0.75, paddingRight: 0.75, '&:hover': { backgroundColor: 'transparent' } }}>
          Compare
        </Button>
         <Button variant="text" disabled={!promptId} onClick={handleTestRunPrompt} sx={{ textTransform: 'none', paddingLeft: 0.75, paddingRight: 0.75, '&:hover': { backgroundColor: 'transparent' } }}>
          {"Test Prompt"}
        </Button>
        <Button
          variant="text"
          sx={{ cursor: "pointer", display:'flex', alignItems:'center', textTransform: 'none', paddingLeft: 0.75, paddingRight: 0.75, '&:hover': { backgroundColor: 'transparent' } }}
          disabled={!promptId}
          onClick={handleAdvOptOpen}
        >
          More {advOpt ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
        </Button>
        
      </Box>
      
      
      {/* Advance options popup */}
      <Popover
        open={advOpt}
        anchorEl={advOptAnchorEl}
        onClose={handleAdvOptClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box sx={{ p: 2, minWidth: 200 }}>
          <Stack spacing={1}>
            <Button variant="text" disabled={!promptId} onClick={handleOpenCopyWarning} sx={{ justifyContent: 'flex-start', textTransform: 'none', '&:hover': { backgroundColor: 'transparent' } }}>
              Duplicate
            </Button>
            {isAssignPrompt &&
              <Button
                variant="text"
                component={Link}
                sx={{ cursor: "pointer", justifyContent: 'flex-start', textTransform: 'none' }}
                disabled={!promptId || data?.assignCompanyId===companyId}
                onClick={(e) => {
                  handleAdvOptClose();
                  handleAssignClickOpen();
                }}
              >
                Set as Default prompt
              </Button>
            }
            <Button
              variant="text"
              sx={{ cursor: "pointer", justifyContent: 'flex-start', textTransform: 'none' }}
              disabled={!promptId || data?.assignCompanyId===defaultGuid}
              onClick={(e) => {
                handleAdvOptClose();
                data?.assignCompanyId===companyId?deleteCompanyPrompt("Remove"):handleAssignClick();
              }}
              color={selectedPromptData?.assignCompanyId===companyId?"error":"primary"}
            >
              {selectedPromptData?.assignCompanyId===companyId?"Remove Company Prompt": "Set as Company Prompt"}
            </Button>
            <Tooltip
              title={isGloballyOrCompanyAssigned ? "Cannot archive a prompt that is assigned globally or to a company" : ""}
              arrow
              disableHoverListener={!isGloballyOrCompanyAssigned}
            >
              <span>
                <Button
                  variant="text"
                  component={Link}
                  sx={{ cursor: "pointer", justifyContent: 'flex-start', textTransform: 'none', width: '100%' }}
                  color="error"
                  disabled={!promptId || data?.status===3 || isGloballyOrCompanyAssigned}
                  onClick={(e) => {
                    handleAdvOptClose();
                    handleArchivedDialogOpen();
                  }}
                >
                  Archive Prompt
                </Button>
              </span>
            </Tooltip>
            <Tooltip
              title={isGloballyOrCompanyAssigned ? "Cannot delete a prompt that is assigned globally or to a company" : ""}
              arrow
              disableHoverListener={!isGloballyOrCompanyAssigned}
            >
              <span>
                <Button
                  variant="text"
                  component={Link}
                  sx={{ cursor: "pointer", justifyContent: 'flex-start', textTransform: 'none', width: '100%' }}
                  disabled={!promptId || isGloballyOrCompanyAssigned}
                  color="error"
                  onClick={(e) => {
                    handleAdvOptClose();
                    handleClickOpen();
                  }}
                >
                  Delete Prompt
                </Button>
              </span>
            </Tooltip>
          </Stack>
        </Box>
      </Popover>
         
      {/* Dialogs */}
      <Dialog open={openDeleteModal} onClose={handleClose}>
        <DialogTitle>Confirm {companyPromptData?.remove ? "Remove" : "Delete"}</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText>
              Are you sure you want to {companyPromptData?.remove ? "remove" : "delete"} this {companyPromptData?.remove ? "company" : ""} prompt?
            </DialogContentText>
          </DialogContent>
          <Divider />
          <DialogActions
            sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
          >
            <Button
              onClick={handleDelete}
              size="small"
              variant="contained"
              color="error"
            >
              {companyPromptData?.remove ? "Remove" : "Delete"} Prompt
            </Button>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openAssignModal} onClose={handleAssignClose}>
          <DialogTitle>Confirm Assign Prompt</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText>
              Are you sure you want to assign this prompt as a {companyPromptData?.assign ? "company" : "default"} prompt?
              {companyPromptData?.assign ? "" : "It will become default for all companies in this environment."}
            </DialogContentText>
          </DialogContent>
          <Divider />
          <DialogActions
            sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
          >
            <Button
              onClick={handleAssignPrompt}
              size="small"
              variant="contained"
              color="error"
            >
              Assign Prompt
            </Button>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={handleAssignClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openCopyWarning} onClose={handleCloseCopyWarning}>
          <DialogTitle>Duplicate Prompt</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText>
              Do you want to make a copy of this prompt?
            </DialogContentText>
          </DialogContent>
          <Divider />
          <DialogActions
            sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
          >
            <Button
              onClick={handleCopyModal}
              size="small"
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={handleCloseCopyWarning}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>




        <Dialog open={openArchiveModal} onClose={handleArchiveDialogClose}>
          <DialogTitle>Confirm Archive Prompt</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText>
              <Typography>  Are you sure you want to archive this {companyPromptData?.remove ? "company" : ""} prompt?</Typography>
              <Typography sx={{fontWeight:'600', mt:.5}}>This action can't be undone.</Typography>
            </DialogContentText>
          </DialogContent>
          <Divider />
          <DialogActions
            sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
          >
            <Button
              onClick={handleArchivePrompt}
              size="small"
              variant="contained"
              color="error"
            >
              Archive Prompt
            </Button>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={handleArchiveDialogClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <div style={{ height: 'calc(100vh - 160px)', overflow: 'hidden auto',  }}>
      <Grid container spacing={2} sx={{ pr:1 }} >
        <Grid item xs={9} sx={{ mt: 2 }}>
          <TextField
            label="Name"
            size="small"
            variant="outlined"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={!isValidPrompt}
            error= {error?.name}
          />
        </Grid>
        <Grid item xs={3} sx={{ mt: 2 }}>

          <TextField

            label="Version"
            size="small"
            value={version ? version : ""}
            onChange={(e) => setVersion(e.target.value)}
            fullWidth
            disabled={!isValidPrompt}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ pr:1 }}>
        <Grid item xs={8}>
          {/* <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth size="small">
            <InputLabel>Type</InputLabel>
            <Select
              size="small"
              label="Type"
              value={type}
              onChange={(e) => { handleType(e.target.value) }}
              disabled={!isValidPrompt}
            >
              <MenuItem value="Agent">Agent</MenuItem>
              <MenuItem value="Business">Business </MenuItem>
              <MenuItem value="Custom">Custom</MenuItem>
              <MenuItem value="Phrase Summary">Phrase Summary</MenuItem>
              <MenuItem value="Response">Response</MenuItem>
              <MenuItem value="Review Request"> Review Request </MenuItem>
              <MenuItem value="Sentiments">Sentiments</MenuItem>
              <MenuItem value="Topics">Topics</MenuItem>
              <MenuItem value="Chat">Chat</MenuItem>
            </Select>
          </FormControl> */}

           <FormControl
                size="small"
                sx={{ 
                  cursor: "pointer", 
                  width: "100%", 
                  mt: 2,
                  // pr: 1, 
                  // border: 'none',
                  // '&:hover .MuiButton-root': {
                  //   border: '1px solid #ccc'
                  // }
                }}
                error={error?.type}
              >
                
                  <Button variant="contained" onClick={(e) => setTypeAnchorEl(e.currentTarget)} sx={{textTransform:'none', minWidth:'250px', height:'40px', backgroundColor: 'transparent', color: theme.palette.text.primary, fontWeight: 'normal', border:`1px solid ${error?.type? theme.palette.error.main : theme.palette.secondary[400]}`, '&:hover':{
                   justifyContent:'space-between', boxShadow: 'none',  backgroundColor: 'transparent'
                  },
                  justifyContent:'space-between', fontSize:'14px !important', paddingLeft:'8px', paddingRight:'4px', boxShadow:'none',
                  '&.Mui-disabled': {backgroundColor: 'transparent'}
                  }}
                  disabled={!isValidPrompt}
                  >
                    <span style={{maxWidth:'250px', whiteSpace:'nowrap', textOverflow:'ellipsis', overflow:'hidden', fontSize:'16px', color: error?.type ? theme.palette.error.main : theme.palette.text.primary}}>
                     {type ? type + (subType ? ` / ${subType}` : '') : 'Select Subtype'}
                     </span> 
                     <span style={{display: 'inline-flex', alignItems: 'center'}}> {typeAnchorEl ? <ArrowDropUpIcon  sx={{color: 'white', fontSize:'24px'}}/> : <ArrowDropDownIcon sx={{color: 'white', fontSize:'24px'}} />}</span>
                  </Button>
                  <Popover

                    open={Boolean(typeAnchorEl)}
                    anchorEl={typeAnchorEl}
                    onClose={() => setTypeAnchorEl(null)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    sx={{
                      maxHeight:'calc(100vh - 250px)',
                      marginTop:'5px',
                      
                      '& .MuiPaper-root': {
                        paddingBottom: '10px',
                        minWidth: '250px',
                        minHeight: '200px',
                      }
                    }}
                  >
                    <Box p={1}>
                    <TextField
                      size="small"
                      placeholder="Search..."
                      onChange={(e) => {setSearchTerm(e.target.value)}}
                      value={searchTerm}
                      fullWidth
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: '14px',
                          padding: '6px 8px'
                        }
                      }}
                      />
                      </Box>
                    {_.map(_.keys(promptTypeSubTypeData), (type) => [
                      <ListSubheader
                        key={`header-${type}`}
                        sx={{ fontWeight: 'bold', lineHeight: '32px', fontSize: '14px', py: 0.5, backgroundColor: theme.palette.mode === 'dark' ? '#343b44' : '#d6e5f9' }}
                      >
                        {type}
                      </ListSubheader>,

                      _.map(promptTypeSubTypeData?.[type], (s) => (
                        <MenuItem
                          key={s}
                          value={s}
                          sx={{ pl: 4, py: 0.5, fontSize: '14px', minHeight: '32px' }}
                          onClick={() =>handleTypeChange(type, s)}
                          selected={s === subType}
                        >
                          {s}
                        </MenuItem>
                      ))
                    ])}
                  </Popover>

              </FormControl>
        </Grid>
        {/* <Grid item xs={4}>
          <FormControl sx={{ mt: 2 }} variant="outlined" size="small" fullWidth>
            <InputLabel id="sub-type-label">Sub Type</InputLabel>
            <Select
              labelId="sub-type-label"
              size="small"
              label="Sub Type"
              value={subTypeMemo.length < 1?'':(type === 'Review Request' && subType === null ? 'All' : (!_.isEmpty(subType) ? subType : null))}
              disabled={_.size(subTypeMemo) < 1 || !isValidPrompt}
              onChange={(e) => setSubType(type === 'Review Request' && e.target.value === 'All' ? null : _.includes(subTypeMemo, e.target.value) ? e.target.value : '')}
              key={`${selectedPromptData?.promptId}`}
            >
              {_.map(_.orderBy(subTypeMemo, it => it, 'asc'), (it, index) => <MenuItem key={`${it}-${index}`} value={it}>{it ? it : ""}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid> */}

          <Grid item xs={4}>
            <FormControl sx={{ mt: 2 }} variant="outlined" size="small" fullWidth >
              <InputLabel>Review Selection Type</InputLabel>
              <Select
                label="Review Selection Type"
                size="small"
                value={reviewType}
                onChange={(e) => setReviewType(e.target.value)}
                disabled={!isValidPrompt}
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Single">Single</MenuItem>
                <MenuItem value="Multiple">Multiple</MenuItem>
              </Select>
            </FormControl>
          </Grid>

      </Grid>



      <TextField
        label="Description"
        size="small"
        sx={{ mt: 2, pr: 1 }}
        // placeholder="Description"
        multiline
        rows={3}
        fullWidth
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        disabled={!isValidPrompt}
      />

      <Grid container spacing={2} sx={{ pr:1 }}>
        <Grid item xs={4} sx={{ mt: 2 }}>
            <FormControl variant="outlined" size="small" fullWidth >
              <InputLabel>AI Provider</InputLabel>
              <Select
                label="AI Provider"
                size="small"
                value="Open AI"
                disabled={!isValidPrompt}
              >
                <MenuItem value="Open AI">Open AI</MenuItem>
              </Select>
            </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl variant="outlined" size="small" sx={{ mt: 2 }} fullWidth>
            <InputLabel>API</InputLabel>
            <Select
              label="API"
              size="small"
              value={api}
              onChange={(e) => setApi(e.target.value)}
              disabled={!isValidPrompt}
            >
              <MenuItem value="completions">Completions</MenuItem>
              <MenuItem value="responses">Responses</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={4}>
          <FormControl variant="outlined" size="small" sx={{ mt: 2 }} fullWidth>
            <InputLabel>LLM</InputLabel>
            <Select
              label="LLM"
              size="small"
              value={llm}
              onChange={(e) => handleLLMChange(e)}
              disabled={!isValidPrompt}
              error={error?.llm}
            >
               {_.map(llmList, llm => <MenuItem key={llm} value={llm}>{llm}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>        

      </Grid>

      <Box
        mt={2}
        position="relative"
      >

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: "24px",
            padding: "0px 8px",
            position: "relative",
          }}
        >
            
            <FormControl size="small" fullWidth sx={{marginLeft: '-8px'}}>
              <InputLabel>Verbosity</InputLabel>
              <Select value={verbosity} label='Verbosity' onChange={e => setVerbosity(e.target.value)}
                disabled={!( _.includes(llm, "gpt-5") || _.includes(llm, "gpt-6") ) || !isValidPrompt}
                >
                <MenuItem value='low'>Low</MenuItem>
                <MenuItem value='medium'>Medium</MenuItem>
                <MenuItem value='high'>High</MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small" fullWidth >
              <InputLabel>Reasoning Effort</InputLabel>
              <Select value={reasoning_effort} label='Reasoning Effort' onChange={e => setReasoningEffort(e.target.value)}
                disabled={!( _.includes(llm, "gpt-5") || _.includes(llm, "gpt-6") ) || !isValidPrompt}
                >
                {!hasLowReasoningEffortFloor(llm) && <MenuItem value={minimalLabel} sx={{textTransform:'capitalize'}}>{_.startCase(minimalLabel)}</MenuItem>}
                <MenuItem value='low'>Low</MenuItem>
                <MenuItem value='medium'>Medium</MenuItem>
                <MenuItem value='high'>High</MenuItem>
              </Select>
            </FormControl>


         
          <Box pb={1}>
            <Box sx={{display:'flex', alignItems:'center'}}>
              <FormControlLabel
                control={
                  <Checkbox checked={isTemperatureChecked} onChange={(e) => setIsTemperatureChecked(e.target.checked)} disabled={!isValidPrompt} />
                }
                label={`Temperature${isTemperatureChecked ? ` (${temperature ?? 0})` : ''}`}
              />
            </Box>
            <Slider
              value={temperature ?? 0}
              size="small"
              min={0}
              max={1}
              step={0.01}
              onChange={handleSliderChange("temperature")}
              valueLabelDisplay="auto"
              disabled={!isValidPrompt || !isTemperatureChecked}
            />
             {/* <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={isTemperatureChecked}
                  onChange={(e) => setIsTemperatureChecked(e.target.checked)}
                  disabled={!isValidPrompt}
                />
              }
              // labelPlacement="top"
              label="Temperature"
              
            /> */}
          </Box>
          <Box pb={1} sx={{ pr: 1}}>
            <Box sx={{display:'flex', alignItems:'center',}}>
              <FormControlLabel
                control={
                  <Checkbox checked={isTopPChecked} onChange={(e) => setIsTopPChecked(e.target.checked)} disabled={!isValidPrompt} />
                }
                label={`Top P${isTopPChecked ? ` (${topP ?? 0})` : ''}`}
              />
            </Box>
            <Slider
              value={topP ?? 0}
              size="small"
              min={0}
              max={1}
              step={0.1}
              onChange={handleSliderChange("topP")}
              valueLabelDisplay="auto"
              disabled={!isValidPrompt || !isTopPChecked}
            />
             {/* <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={topP}
                  onChange={(e) => setTopP(e.target.checked)}
                  disabled={!isValidPrompt}
                />
              }
              // labelPlacement="top"
              label="Top P"
              
            /> */}
          </Box>
          <div>
            <Typography>Presence Penalty ({presencePenalty})</Typography>
            <Slider
              value={presencePenalty}
              size="small"
              min={0}
              max={2}
              step={0.01}
              onChange={handleSliderChange("presencePenalty")}
              valueLabelDisplay="auto"
              disabled={!isValidPrompt}
            />
          </div>

          <div>
            <Typography>Frequency Penalty ({frequencyPenalty})</Typography>
            <Slider
              value={frequencyPenalty}
              size="small"
              min={0}
              max={2}
              step={0.01}
              onChange={handleSliderChange("frequencyPenalty")}
              valueLabelDisplay="auto"
              disabled={!isValidPrompt}
            />
          </div>
          {/* <div>
            <Typography>Input Factor ({inputFactor + "%"})</Typography>
            <Slider
              value={inputFactor}
              size="small"
              min={10}
              max={100}
              step={5}
              onChange={handleSliderChange("inputFactor")}
              valueLabelDisplay="auto"
            />
          </div> */}
          <div>
            <Typography>Max Input Length ({maxLength / 1000 + "k"})</Typography>
            <Slider
              value={maxLength / 1000}
              // getAriaValueText={valuetext}
              size="small"
              min={0.5}
              slots={{
                valueLabel: ValueLabelComponent,
              }}
              max={gptUsageLimit[llm]}
              step={0.5}
              onChange={handleSliderChange("maxLength")}
              valueLabelDisplay="auto"
              disabled={!isValidPrompt}
            />
          </div>
          <div>
            {/* <Typography>Input Factor ({inputFactor + '%'})</Typography> */}
            <FormControl size="small" fullWidth>
              <InputLabel>Seed</InputLabel>
              <Select value={seed} label='Seed' onChange={e => setSeed(e.target.value)} disabled={!isValidPrompt}>
                <MenuItem value='None'>None</MenuItem>
                <MenuItem value='Fixed'>Fixed</MenuItem>
                <MenuItem value='Random'>Random</MenuItem>
              </Select>
            </FormControl>

          </div>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={jsonResponse}
                  onChange={(e) => setJsonResponse(e.target.checked)}
                  disabled={!isValidPrompt}
                />
              }
              // labelPlacement="top"
              label="Json Response"
            />
          </div>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={jsonResponseSchema}
                  onChange={(e) => setJsonResponseSchema(e.target.checked)}
                  disabled={!isValidPrompt}
                />
              }
              // labelPlacement="top"
              label="Response Json Schema"
            />
          </div>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={web_search}
                  onChange={(e) => setWeb_search(e.target.checked)}
                  disabled={!isValidPrompt}
                />
              }
              // labelPlacement="top"
              label="Website Research Tool"
            />
          </div>
          <div>
            <Tooltip title="Extended prompt cache retention" arrow disableInteractive>
              <FormControlLabel label="Caching" name="cached" control={<Checkbox checked={cached} onChange={(e)=>setCached(e.target.checked)} disabled={!isValidPrompt}/>}/>
            </Tooltip>            
          </div>
          {/* {llm==='o3' && <div>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={deepResearch}
                  onChange={(e) => setDeepResearch(e.target.checked)}
                />
              }
              // labelPlacement="top"
              label="Deep Research"
            />
          </div>} */}

        </div>
      </Box>

      <Box sx={{ fontSize: "small", pt: 1 }} className="text-muted">
        <Stack>Prompt Id: {data?.promptId}</Stack>
        <Stack direction={"row"} sx={{ alignContent: "end" }}>
          <Stack> Created by {userDic[data?.createdBy]?.name}</Stack>
          <Stack sx={{ pl: 0.5 }}>
            on{" "}
            {data?.createdOn
              ? moment
                .utc(data?.createdOn)
                .local()
                .format("MM/DD/YYYY hh:mm A")
              : ""}{" "}
          </Stack>
        </Stack>
        {/* <Stack direction={'row'} sx={{ alignContent: 'end',}}>
          <Stack> Last Modified by {userDic[data?.modifiedBy]} </Stack>
          <Stack sx={{ pl: 0.5 }}>on {data?.modifiedOn ? moment(data?.modifiedOn).format('MM/DD/YYYY hh:mm A') : ''} </Stack>
        </Stack> */}
        <Stack direction={"row"} sx={{ alignContent: "end" }}>
          <Stack>
            Last Modified{" "}
            {typeof userDic[data?.modifiedBy]?.name !== "undefined"
              ? "by"
              : ""}{" "}
            {userDic[data?.modifiedBy]?.name}
          </Stack>
          <Stack sx={{ pl: 0.5 }}>
            on{" "}
            {data?.modifiedOn
              ? moment
                .utc(data?.modifiedOn)
                .local()
                .format("MM/DD/YYYY hh:mm A")
              : ""}{" "}
          </Stack>
        </Stack>
      </Box> 
</div>
      {openHistory && <HistoryPromptDetails open={openHistory} handleClose={handleCloseHistory} promptId={data?.promptId} />}
      {openCompare && <ComparePrompt open={openCompare} handleClose={handleCloseCompare} selectedPromptId={promptId} companyId={companyId} />}
    </Box>
  );
};

export default PromptDetail;
